import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldText from "../../fields3/generic/text/text";
import FieldString from "../../fields3/generic/string/string";

const baseConfig = [
    {
        fieldId : 'name',
        type    : FieldType.STRING,
        label   : 'Name'
    },
    {
        fieldId : 'ipAddresses',
        type    : FieldType.TEXT,
        label   : 'IP Addresses'
    },
]

export default class OfficeFields extends FieldsCollection {

    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed
        super(fieldsConfig, EntityType.OFFICE);
    }

    get name()                      { return this.get('name') as FieldString }
    get ipAddresses()               { return this.get('ipAddresses') as FieldText }
}
